module.exports = __webpack_public_path__ + "static/media/Goku_s_Algorythmia_Expedition.a9a333df.pdf";